// Símbolo "G" da marca (mesma geometria de public/brand/gms-tech-simbolo.svg),
// inline para o pixel poder piscar.
type SymbolProps = {
  size: number
  stroke?: string
  pixel?: string
  blink?: boolean
  className?: string
}

export function LogoSymbol({ size, stroke = "#0B0D12", pixel = "#6E4BFF", blink = false, className }: SymbolProps) {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} style={{ flex: "none" }}>
      <path
        d="M28 8H18A10 10 0 0 0 8 18V30A10 10 0 0 0 18 40H30A10 10 0 0 0 40 30V24H28"
        stroke={stroke}
        strokeWidth="8"
        strokeLinejoin="round"
      />
      <rect className={blink ? "gms-cursor" : undefined} x="36" y="4" width="8" height="8" rx="2" fill={pixel} />
    </svg>
  )
}

// Símbolo + "GMS Tech"
export function LogoLockup({ size, textSize, blink }: { size: number; textSize: number; blink?: boolean }) {
  return (
    <>
      <LogoSymbol size={size} blink={blink} />
      <span className="whitespace-nowrap font-bold tracking-[-0.035em]" style={{ fontSize: textSize }}>
        GMS<span className="font-medium text-gms-subtle"> Tech</span>
      </span>
    </>
  )
}
